import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';

import { IAdvancedFormField } from './advanced-form-fields.model';
import { IValidationRules, IFormValidatorList, IAsyncValidationError } from './advanced-form-validation.model';

export interface IAdvancedFormConfig {
  formSectionList: IAdvancedFormSection[];
  actionList: IAction[];
  legalText?: string;
  initialFormData?: IInitialFormData;
  fieldsExtraOptions?: IFieldsExtraOptions;
  formValidatorList?: IFormValidatorList;
  validationRules?: IValidationRules;
  updateOn?: 'change' | 'blur' | 'submit';
}

export interface IAdvancedFormSection {
  title?: string;
  fieldList: IAdvancedFormField[];
  customTagList?: ICustomTagList[];
}

export interface ICustomTagList {
  type: 'text' | 'tooltip';
  name: string;
  text: string;
  class?: string;
}

export interface IInitialFormData {
  [key: string]: any;
}

export interface IFormConfig {
  [key: string]: FormControl;
}

export interface IFieldsExtraOptions {
  [key: string]: IExtraOptions;
}

export interface IAdvancedFormEvent {
  type: string;
  payload: IAdvancedFormPayload | any;
  done(asyncValidationError?: IAsyncValidationError): void;
}

interface IAdvancedFormPayload {
  formData: { [key: string]: any };
  isDirty: boolean;
}

export interface IAdvancedFormContainer {
  advancedFormConfig$?: Observable<IAdvancedFormConfig>;
  advancedFormConfig?: IAdvancedFormConfig;
  onAdvancedFormEvents(event: IAdvancedFormEvent): void;
}

export interface IAdvancedFormData {
  [key: string]: string | boolean | null;
}

export interface IFormData {
  [key: string]: string | boolean;
}

export interface IAction {
  text: string;
  type: string;
  extras?: IExtraOptions;
}

interface IExtraOptions {
  [key: string]: any;
}

export enum AdvancedFormEventTypes {
  submit = 'submit',
  validation = 'validation',
  skip = 'skip',
}
